import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { createBrowserHistory } from 'history';
const trackingId = "UA-170669374-2";
ReactGA.initialize(trackingId);
ReactGA.set({
  userId: 'BookingLinkUser',
  // any data that is relevant to the user session
  // that you would like to track with google analytics
});

const history = createBrowserHistory();
// Initialize google analytics page view tracking
history.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

ReactDOM.render(<Router history={history}><App /></Router>, document.getElementById('root'));